import { render, staticRenderFns } from "./WebHeader.vue?vue&type=template&id=46519120&scoped=true&"
import script from "./WebHeader.vue?vue&type=script&lang=ts&"
export * from "./WebHeader.vue?vue&type=script&lang=ts&"
import style0 from "./WebHeader.vue?vue&type=style&index=0&id=46519120&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46519120",
  null
  
)

export default component.exports